import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class SesionService {
  setItem<T>(key: string, data: T) {
    sessionStorage.setItem(key, JSON.stringify(data));
  }

  getItem<T>(key: string): T | null {
    return this.getSesion<T>(key);
  }

  private getSesion<T>(key: string): T | null {
    let sesion = sessionStorage.getItem(key);
    if (sesion) {
      let data: T = JSON.parse(sesion);
      return data;
    } else {
      return null;
    }
  }
}
